export const DEFAULT_PLAYBOOK_CONTACTS_COUNT = 20;
export const MAX_PLAYBOOK_CONTACTS_COUNT = 50;

export const getPlaybookContactsCount = (contactsCount?: number): number =>
    contactsCount && contactsCount > 0 ? contactsCount : DEFAULT_PLAYBOOK_CONTACTS_COUNT;
